module.exports = __webpack_public_path__ + "img/og-image_ipad.16ea93c.jpg";